export default class FloatingLabelInput extends Backbone.View {
    template({className, id, label, type}) {
        return `
            <div class="floatingLabelInput ${className}">
                <input id="${id}" name="${id}" type="${type}" aria-label="${label}" ${this.autocompleteHint ? `autocomplete="${this.autocompleteHint}"` : ''}>
                <label class="inputLabel" labelFor="${id}" title="${label}">${label}</label>
                ${type === 'password' ? `
                    <img class="showPasswordIcon" alt='${ window.text('signInPage.libraryCard.showPassword') }' src='${ window.OverDrive.cdn }/public/img/icon-password-show.png'/>
                    <img class="showPasswordIcon" style="display: none" alt='${ window.text('signInPage.libraryCard.hidePassword') }' src='${ window.OverDrive.cdn }/public/img/icon-password-hide.png'/>
                ` : ''}
                <p class="invalidLabel">${window.text('signInPage.invalidField', {fieldName: label})}</p>
            </div>`;
    }

    constructor({ className, id, label, type, autocompleteHint}) {
        super(...arguments);

        this.type = type || 'text';
        this.floated = false;
        this.floatPollIntervalMS = 100;

        _.extend(this, arguments[0]);
    }

    render() {
        this.eventsAttached = false;
        this.$el.empty().append(this.template(this));
        this.$input = this.$el.find('input');
        this._attachEvents();
        return this;
    }

    _attachEvents() {
        if (!this.eventsAttached){
            this.$input.on('focus input change', () => {
                this.floatLabel();
            });


            this.$input.on('blur', () => {
                if (!this.$input.val()){
                    this.sinkLabel();
                }
            });

            if (window.featureManager.isEnabled('pollForAutofill')){
                console.log('start polling');
                setTimeout(() => this.checkForWebkitAutofill(), this.floatPollIntervalMS);
            }

            if (this.type === 'password') {
                this.$input.css('padding-right', '3rem');
                this.$el.find('.showPasswordIcon').click(() => {
                    this.$el.find('.showPasswordIcon').toggle();
                    this.$input.focus();
                    if (this.$input.attr('type') === 'password') {
                        this.$input.attr('type', 'text');
                    }
                    else {
                        this.$input.attr('type', 'password');
                    }
                });
            }
            this.eventsAttached = true;
        }
    }


    // poll for autofill by webkit.  Webkit browsers
    // do not trigger any event on autofill until the user
    // interacts with the page in some way.  The autofilled
    // value is also not available on the element until that time.
    // However, the browser-specific pseudo class is applied.
    checkForWebkitAutofill(){

        if (this.$input.is(':-webkit-autofill') && !this.floated){
            this.floatLabel();
        }

        // Since we are solely concerned with autofill and other cases are covered by explicit events,
        // we can stop polling as soon as the label is floated
        if (!this.floated){
            setTimeout(() => this.checkForWebkitAutofill(), this.floatPollIntervalMS);
        }
    }

    floatLabel(){
        if (window.featureManager.isEnabled('pollForAutofill') && this.floated){
            return;
        }

        this.$el.find('.inputLabel').addClass('secondary-color');
        this.$el.find('.floatingLabelInput').addClass('focused');
        this.floated = true;
    }

    sinkLabel(){
        if (window.featureManager.isEnabled('pollForAutofill') && !this.floated){
            return;
        }

        this.$el.find('.inputLabel').removeClass('secondary-color');
        this.$el.find('.floatingLabelInput').removeClass('focused');
        this.floated = false;
    }

    validateNonEmpty() {
        if (this.$input.val()) {
            return true;
        }
        this.displayInvalid();
        return false;
    }

    displayInvalid() {
        if (!this.invalid){
            this.$el.find('.floatingLabelInput').addClass('invalid');
            this.$input.on('focus', () => {
                this.clearInvalid();
            });
            this.invalid = true;
        }
    }

    clearInvalid(){
        if (this.invalid){
            this.$el.find('.floatingLabelInput').removeClass('invalid');
            this.invalid = false;
        }
    }
}
